// extracted by mini-css-extract-plugin
export default {"theme":"Theme_theme__hrgiE","input":"Theme_input__ZbgxM","inner":"Theme_inner__GxBJx","box":"Theme_box__JAqn3","icon":"Theme_icon__GyLWV","small":"Theme_small__ZANhz"};